'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _DynamicSidebar = require('./DynamicSidebar.styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicSidebar = function (_React$PureComponent) {
  _inherits(DynamicSidebar, _React$PureComponent);

  function DynamicSidebar() {
    _classCallCheck(this, DynamicSidebar);

    return _possibleConstructorReturn(this, (DynamicSidebar.__proto__ || Object.getPrototypeOf(DynamicSidebar)).apply(this, arguments));
  }

  _createClass(DynamicSidebar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          text = _props.text,
          url = _props.url,
          image = _props.image,
          transition = _props.transition;

      var key = url || image;

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          component: _DynamicSidebar.Wrapper,
          transitionName: 'fadein',
          transitionAppear: true,
          transitionAppearTimeout: 1000,
          transitionEnterTimeout: 1000,
          transitionLeaveTimeout: 1000,
          transitionLeave: false,
          transitionEnter: transition
        },
        _react2.default.createElement(
          'div',
          { className: 'sidebar-dynamic', key: key },
          image && _react2.default.createElement(_DynamicSidebar.Illustration, { name: image }),
          url && _react2.default.createElement(_DynamicSidebar.Image, { src: url }),
          _react2.default.createElement(
            _DynamicSidebar.Title,
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: title })
          ),
          _react2.default.createElement(
            _DynamicSidebar.Text,
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: text })
          )
        )
      );
    }
  }]);

  return DynamicSidebar;
}(_react2.default.PureComponent);

DynamicSidebar.propTypes = {
  title: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string,
  image: _propTypes2.default.string,
  transition: _propTypes2.default.bool
};
DynamicSidebar.defaultProps = {
  transition: true
};
exports.default = DynamicSidebar;
module.exports = exports['default'];